import $ from "jquery";
import noUiSlider from "nouislider";
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

import { MarkerClusterer } from "@googlemaps/markerclusterer";

import lottie from "lottie-web/build/player/lottie_light.min.js";

export function searchProperties() {
	var slider;
	let map;
	var latestResponse = null;
	let markers = [];
	let latLngs = [];
	var markerCluster = null;
	var budgetUpdate = false;
	var oldMin = null;
	var oldMax = null;

	//If on homepage (if homepage class exists)
	if (document.querySelector(".homepage")) {
		// Target your form by its class, ID, or element
		var form = document.querySelector("form#search-properties");

		form.addEventListener("submit", function (event) {
			// Prevent the default form submission
			event.preventDefault();

			// Construct a FormData object from the form. It's useful for inspection and modification.
			var formData = new FormData(form);

			// Define the default values for your fields
			var defaultValues = {
				regions: "",
				checkin: "", // Assuming an empty string represents the default state for the date
				nights: "", // Default value
				guests: "Guests (aged 2+)", // Assuming it's a placeholder like 'Anywhere'
				pets: "0", // Default value
				flexibility: "0", // Default value
			};

			// Iterate over the defaultValues object
			for (var key in defaultValues) {
				if (formData.has(key) && (formData.get(key) == defaultValues[key] || formData.get(key) === "")) {
					// If the field's value is the default value, delete it from the FormData object
					formData.delete(key);
				}
			}

			//If formData has properties, delete
			if (formData.has("properties")) {
				formData.delete("properties");
			}

			// Construct the query string from the FormData object
			var queryString = new URLSearchParams(formData).toString();

			//Get URL excluding domain and query string
			var url = window.location.pathname;

			// Redirect to the target URL with the non-default query parameters
			if (queryString !== "" && queryString !== null) {
				window.location.href = url + "availability?" + queryString;
			} else {
				window.location.href = url + "availability";
			}
		});
	} else if (document.querySelector(".search-availability")) {
		/*var form = document.querySelector('form#search-properties');

		form.addEventListener('submit', function (event) {
			// Prevent the default form submission
			event.preventDefault();
			showSearchLoader();
			var formData = collectFormValues();
			makeAjaxCall(formData);
		});*/
	}

	// When any button with an aria-controls attribute that starts with 'filter-section-' is clicked
	$("button[aria-controls^='filter-section-']").on("click", function () {
		// Get the value of the aria-controls attribute
		var sectionId = $(this).attr("aria-controls");

		// Toggle the corresponding section with a sliding effect
		$("." + sectionId).toggleClass("hidden");

		//Hide the SVG that does not have the hidden class and show the SVG that does have the hidden class
		$(this).find("svg").toggleClass("hidden");

		// Optional: Toggle the aria-expanded attribute value
		var isExpanded = $(this).attr("aria-expanded") === "true";
		$(this).attr("aria-expanded", !isExpanded);
	});

	function collapseAllSections() {
		// Find all buttons that control collapsible sections
		var buttons = $("button[aria-controls^='filter-section-']");

		// For each button
		buttons.each(function () {
			// Get the value of the aria-controls attribute
			var sectionId = $(this).attr("aria-controls");

			// Add the 'hidden' class to the corresponding section to hide it
			$("." + sectionId).addClass("hidden");

			// Show the SVG that has the 'hidden' class and hide the SVG that does not have the 'hidden' class
			$(this).find("svg.plus-icon").removeClass("hidden");
			$(this).find("svg.minus-icon").addClass("hidden");

			// Set the aria-expanded attribute value to false
			$(this).attr("aria-expanded", false);
		});
	}

	function createSlider() {
		//slider = document.getElementById('slider');
		//Get each element with class .budgetSlider
		var sliders = document.querySelectorAll(".budgetSlider");

		for (var i = 0; i < sliders.length; i++) {
			var slider = sliders[i];

			var max = slider.getAttribute("data-max");
			var min = slider.getAttribute("data-min");
			var low = slider.getAttribute("data-low");
			var high = slider.getAttribute("data-high");

			//Convert to integer
			max = parseInt(max);
			min = parseInt(min);
			low = parseInt(low);
			high = parseInt(high);

			if (low === null) {
				low = 100;
			}
			if (high === null) {
				high = 5000;
			}

			noUiSlider.create(slider, {
				start: [min, max], // Starting values: min and max prices
				connect: true, // Display a colored bar between the handles
				range: {
					min: 100,
					max: 5000,
				},
				step: 50,
				tooltips: true, // Show tooltips above handles
				format: {
					to: function (value) {
						// Format the number as currency with thousands separator
						return "£" + new Intl.NumberFormat("en-GB").format(value.toFixed(0));
					},
					from: function (value) {
						// Remove the £ symbol and convert back to a number
						return Number(value.replace(/£/, "").replace(/,/g, ""));
					},
				},
			});

			//Select nouisslider range

			// Update the input fields when the slider value changes
			slider.noUiSlider.on("update", function (values, handle) {
				var value = values[handle];
				if (handle) {
					// if handle is 1, it's the upper slider
					$("#maxPrice").val(value);
				} else {
					// if handle is 0, it's the lower slider
					$("#minPrice").val(value);
				}
			});

			// Optional: If you want the inputs to also update the slider (one-way binding)
			$("#minPrice").on("change", function () {
				slider.noUiSlider.set([this.value, null]);
			});

			$("#maxPrice").on("change", function () {
				slider.noUiSlider.set([null, this.value]);
			});

			slider.noUiSlider.on("change", function (values, handle) {
				showSearchLoader();
				var formData = collectFormValues();
				budgetUpdate = true;
				makeAjaxCall(formData);
			});
		}
	}

	function updatePropertiesCards(data) {
		var $propertiesDiv = $("#properties");
		// Assuming you've corrected the <script> template to be a suitable jQuery template
		var $cardTemplate = $($.trim($("#property-card-template").html()));

		// Clear existing cards
		$propertiesDiv.empty();

		// Iterate over each property in the response data
		$.each(data, function (index, property) {
			// Clone the template to work with a fresh copy for each property
			var $card = $cardTemplate.clone();

			//Format price, remove decimal places and add thousands separator
			property.price = new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(property.price);
			property.price = property.price.split(".")[0]; //Remove decimal places

			if(property.original_price !== null) {
				property.original_price = new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(property.original_price);
				property.original_price = property.original_price.split(".")[0]; //Remove decimal places
			}

			//Format dates
			var start_date = new Date(property.start_date);
			var end_date = new Date(property.end_date);

			property.dates = formatDayWithSuffix(start_date) + " " + start_date.toLocaleDateString("en-GB", { month: "long" }) + " - " + formatDayWithSuffix(end_date) + " " + end_date.toLocaleDateString("en-GB", { month: "long" });

			// Update elements within the card. Adjust these selectors to match your actual template structure.
			$card.attr("data-property-id", property.property_id); // Assuming the top-level of your template should have the data-property-id
			$card.find("[data-card-link]").attr("href", property.link);
			$card.find("[data-card-title]").text(property.title);
			$card.find("[data-card-location]").text(property.location);

			if (property.discounted) {
				$card.find("[data-card-price]").html('<span class="line-through text-gray-400 mr-2 text-sm align-middle w-full block -mb-3">was ' + property.original_price + '</span><span class="text-base opacity-75">now</span> ' + property.price);
				$card.find("[data-card-dates]").text(property.dates);
			} else if (property.start_date === null) {
				//$card.find('[data-card-price]').removeClass('text-xl').addClass('text-md').text('From '+property.price+' per night');
				$card.find("[data-card-dates]").text("");
			} else {
				$card.find("[data-card-price]").text(property.price);
				$card.find("[data-card-dates]").text(property.dates);
			}
			$card.find("[data-card-bedrooms]").text(property.bedrooms);
			$card.find("[data-card-bathrooms]").text(property.bathrooms);
			$card.find("[data-card-sleeps]").text(property.sleeps);

			if (property.pets === false) {
				$card.find("[data-card-pets]").removeClass("hidden");
			}

			//For each image in the property, create a new swiper slide
			var $swiperWrapper = $card.find(".swiper-wrapper");
			$.each(property.photos, function (index, image) {
				var $swiperSlide = $(
						'<div class="swiper-slide"><picture class="block relative w-full h-full z-10 top-0 pointer-events-none overflow-hidden"><div class="aspect-ratio-16/9"></div><source srcset="' +
							image.srcset +
							'" type="image/jpeg"><img loading="lazy" class="absolute left-0 top-0 inset-0 w-full h-full object-cover group-hover:scale-105 transform transition duration-500" object-fit="cover" srcset="' +
							image.small +
							" 480w, " +
							image.medium +
							" 800w, " +
							image.large +
							' 1200w" sizes="(max-width: 640px) 100vw, 50vw" alt=""></picture></div>'
					);
				$swiperWrapper.append($swiperSlide);
			});

			// Append the new card to the properties div
			$propertiesDiv.append($card);
		});

		$(".found-results").html("<strong>" + data.length + "</strong> available properties found");

		//Reload Swiper
		initPropertyCardSwiper();
	}

	function updateSuggestedPropertiesCards(data) {
		var $propertiesDiv = $("#suggested-properties");
		// Assuming you've corrected the <script> template to be a suitable jQuery template
		var $cardTemplate = $($.trim($("#property-card-template").html()));

		// Clear existing cards
		$propertiesDiv.empty();

		//console.log('updateSuggestedPropertiesCards');
		//console.log('data', data);

		// Iterate over each property in the response data
		$.each(data, function (index, property) {
			// Clone the template to work with a fresh copy for each property
			var $card = $cardTemplate.clone();

			//Format price, remove decimal places and add thousands separator
			property.price = new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(property.price);
			property.price = property.price.split(".")[0]; //Remove decimal places

			//Format dates
			var start_date = new Date(property.start_date);
			var end_date = new Date(property.end_date);
			property.dates = start_date.toLocaleDateString("en-GB", { day: "numeric", month: "long" }) + " - " + end_date.toLocaleDateString("en-GB", { day: "numeric", month: "long" });

			// Update elements within the card. Adjust these selectors to match your actual template structure.
			$card.attr("data-property-id", property.property_id); // Assuming the top-level of your template should have the data-property-id
			$card.find("[data-card-link]").attr("href", property.link);
			$card.find("[data-card-title]").text(property.title);
			$card.find("[data-card-location]").text(property.location);

			if (property.start_date === null) {
				//$card.find('[data-card-price]').removeClass('text-xl').addClass('text-md').text('From '+property.price+' per night');
				$card.find("[data-card-dates]").text("");
			} else {
				$card.find("[data-card-price]").text(property.price);
				$card.find("[data-card-dates]").text(property.dates);
			}
			$card.find("[data-card-bedrooms]").text(property.bedrooms);
			$card.find("[data-card-bathrooms]").text(property.bathrooms);
			$card.find("[data-card-sleeps]").text(property.sleeps);

			if (property.pets === false) {
				$card.find("[data-card-pets]").removeClass("hidden");
			}

			//For each image in the property, create a new swiper slide
			var $swiperWrapper = $card.find(".swiper-wrapper");
			$.each(property.photos, function (index, image) {
				var $swiperSlide = $(
						'<div class="swiper-slide"><picture class="block relative w-full h-full z-10 top-0 pointer-events-none overflow-hidden"><div class="aspect-ratio-16/9"></div><source srcset="' +
							image.srcset +
							'" type="image/jpeg"><img loading="lazy" class="absolute left-0 top-0 inset-0 w-full h-full object-cover group-hover:scale-105 transform transition duration-500" object-fit="cover" srcset="' +
							image.small +
							" 480w, " +
							image.medium +
							" 800w, " +
							image.large +
							' 1200w" sizes="(max-width: 640px) 100vw, 50vw" alt=""></picture></div>'
					);
				$swiperWrapper.append($swiperSlide);
			});

			// Append the new card to the properties div
			$propertiesDiv.append($card);
		});

		//Reload Swiper
		initPropertyCardSwiper();
	}

	// Function to collect all form values
	function collectFormValues() {
		//Reset formData
		var formData = {};

		// Collect values from the date picker, nights dropdown, and guests dropdown
		$("form#search-properties input[name=checkin], form#search-properties select[name=nights], form#search-properties select[name=guests], form#search-properties select[name=pets], form#search-properties select[name=flexibility]").each(function () {
			formData[$(this).attr("name")] = $(this).val();
		});

		//Collect orderBy value
		formData["orderBy"] = $("select[name=orderBy]").val();

		//If mobile view, collect values from the search-sidebar
		if (window.innerWidth < 1024) {
			$("form.search-sidebar-mob input[type=checkbox]:checked, form.search-sidebar-mob input[type=radio]:checked").each(function () {
				var name = $(this).attr("name");
				// Handle checkboxes as arrays
				if (name.endsWith("[]")) {
					name = name.replace("[]", "");
					if (!formData[name]) {
						formData[name] = [];
					}
					formData[name].push($(this).val());
				} else {
					formData[name] = $(this).val();
				}
			});
		} else {
			$("form.search-sidebar input[type=checkbox]:checked, form.search-sidebar input[type=radio]:checked").each(function () {
				var name = $(this).attr("name");
				// Handle checkboxes as arrays
				if (name.endsWith("[]")) {
					name = name.replace("[]", "");
					if (!formData[name]) {
						formData[name] = [];
					}
					formData[name].push($(this).val());
				} else {
					formData[name] = $(this).val();
				}
			});
		}

		//Get values of #minPrice and #maxPrice
		formData["minPrice"] = $("#minPrice").val().replace(/£/, "").replace(/,/g, "");
		formData["maxPrice"] = $("#maxPrice").val().replace(/£/, "").replace(/,/g, "");

		//console.log('formData', formData);

		/*var priceRange = slider.noUiSlider.get();
		formData['min_price'] = priceRange[0].replace(/£/, '').replace(/,/g, '');
		formData['max_price'] = priceRange[1].replace(/£/, '').replace(/,/g, ''); */

		return formData;
	}

	function updateUrl(data) {
		//console.log('updateUrl');
		//console.log(data);

		var url = new URL(window.location.href);

		// Remove any existing query parameters
		url.search = "";

		//Check to see if towns exists in data, if so, add regions to URL
		var towns = null;
		if (data["towns"] !== undefined) {
			towns = data["towns"];
		}

		//Remove towns from data
		delete data["towns"];

		if (data["checkin"] !== "") {
			for (var key in data) {
				if (key === "regions" && towns !== null) {
					if (Array.isArray(data[key]) && Array.isArray(towns)) {
						url.searchParams.set("regions", data[key].join(",") + "|" + towns.join(","));
					} else {
						url.searchParams.set(key, data[key] + "|" + towns.join(","));
					}
				} else if (Array.isArray(data[key])) {
					//Comma separate the array
					url.searchParams.set(key.replace("[]", ""), data[key].join(","));
				} else {
					url.searchParams.set(key, data[key]);
				}
			}

			//Remove properties from URL
			url.searchParams.delete("properties");

			//console.log(url);
			history.pushState({}, "", url);
		}
	}

	function isInViewport(element) {
		const rect = element.getBoundingClientRect();
		return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
	}

	function trackSearchData(data) {
		var analyticsData = data;
		if (analyticsData.regions === undefined) {
			analyticsData.regions = null;
		} else {
			analyticsData.regions = data.regions.join(",");
		}

		if (analyticsData.guests === undefined || analyticsData.guests == "" || analyticsData.guests == "Guests (aged 2+)") {
			analyticsData.guests = null;
		}
		if (analyticsData.checkin === undefined || analyticsData.checkin == "") {
			analyticsData.checkin = null;
		}
		if (analyticsData.nights === undefined || analyticsData.nights == "") {
			analyticsData.nights = null;
		}
		if (analyticsData.properties === undefined || analyticsData.properties == "") {
			analyticsData.properties = 0;
		}

		console.log({
			guests: analyticsData.guests,
			regions: analyticsData.regions,
			checkin: analyticsData.checkin,
			nights: analyticsData.nights,
			properties: analyticsData.properties,
		});

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: "property_search",
			guests: analyticsData.guests,
			regions: analyticsData.regions,
			checkin: analyticsData.checkin,
			nights: analyticsData.nights,
			properties: analyticsData.properties,
		});
	}

	// Function to make the AJAX call
	function makeAjaxCall(data) {
		$("#no-properties").addClass("hidden");

		closeSearchSidebars();

		if(data.checkin) {
			$(".orderby-container").removeClass('hidden');
		} else {
			$(".orderby-container").addClass("hidden");
		}

		var analyticsData = data;

		$.ajax({
			url: ajax.ajaxurl,
			type: "POST",
			data: {
				action: "search_availability", // This should match the action hook part in PHP
				data, // Spread collected form data
			},
			success: function (response) {
				console.log("Response:", response);
				latestResponse = response;
				if (response.success) {
					analyticsData.properties = response.data.properties.length;
					trackSearchData(analyticsData);
					if (response.data.properties && response.data.properties.length > 0) {
						updatePropertiesCards(response.data.properties);
						updateUrl(data);
						updateMarkers(response.data.properties);

						//Update slider range
						/*if (!budgetUpdate) {
							
							//Check if we have a start date submitted
							if(data.checkin !== '') {

								var minPrice = 1000000;
								var maxPrice = 0;
								response.data.properties.forEach(function (property) {
									//Replace £ and , and convert to integer
									property.price = parseInt(property.price.replace(/£/, '').replace(/,/g, ''));

									if (property.price < minPrice) {
										minPrice = property.price;
									}
									if (property.price > maxPrice) {
										maxPrice = property.price;
									}
								});
							} else {
								var minPrice = 100;
								var maxPrice = 5000;
							}

							minPrice = parseInt(minPrice);
							maxPrice = parseInt(maxPrice);

							console.log('minPrice', minPrice);
							console.log('maxPrice', maxPrice);

							var sliders = document.querySelectorAll('.budgetSlider');

							for (var i = 0; i < sliders.length; i++) {
								var slider = sliders[i];
								console.log(slider);
								slider.noUiSlider.updateOptions({ range: { 'min': minPrice, 'max': maxPrice } });
							}
						}*/
					} else {
						$(".found-results").html("<strong>0 available properties</strong> found");
						$("#no-properties").removeClass("hidden");
						$("#properties").empty();

						//console.log('Suggested properties');
						//console.log(response.data.suggested_properties);
						if (response.data.suggested_properties && response.data.suggested_properties.length > 0) {
							$("#suggested-properties").empty();
							updateSuggestedPropertiesCards(response.data.suggested_properties);
						}

						updateUrl(data);
					}
					//Smooth scroll to .search-results if .search-results is not in view
					const element = document.querySelector(".found-results");
					if (!isInViewport(element)) {
						$("html, body").animate(
							{
								scrollTop: $(".search-results").offset().top,
							},
							400
						);
					}

					hideSearchLoader();
					budgetUpdate = false;
				}
				// Handle your response here. For example, update the UI with the results.
			},
			error: function (error) {
				console.error("Error:", error);
			},
		});
	}

	function showSearchLoader() {
		//console.log('showSearchLoader');
		initLoadingAnimation();
		$(".loading-screen").removeClass("hidden");
	}

	function hideSearchLoader() {
		//console.log('hideSearchLoader');
		removeLoadingAnimation();
		$(".loading-screen").addClass("hidden");
	}

	// Initialize Swiper
	function initPropertyCardSwiper() {
		var swipers = document.querySelectorAll(".property-card .swiper-container");

		swipers.forEach(function (swiperContainer) {
			new Swiper(swiperContainer, {
				modules: [Navigation, Pagination],
				// Swiper options here
				lazy: true,
				pagination: {
					el: ".swiper-pagination",
					type: "fraction",
				},
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				loop: true,
			});
		});
	}

	// Function to initialize the map
	async function initMap() {
		// Import the necessary libraries from the Google Maps API
		const { Map } = await google.maps.importLibrary("maps");
		const markerLibraries = await google.maps.importLibrary("marker");

		// Attach the needed classes to the window object for global access
		window.AdvancedMarkerElement = markerLibraries.AdvancedMarkerElement;
		window.PinElement = markerLibraries.PinElement;

		// Initialize the map
		map = new Map(document.getElementById("properties-google-map"), {
			zoom: 8,
			center: { lat: 52.924, lng: -4.237 },
			mapId: "properties_map",
		});

		if (latestResponse === null) {
			var allProperties = initProperties;
		} else if (latestResponse.data) {
			var allProperties = latestResponse.data;
		} else {
			var allProperties = [];
		}

		updateMarkers(allProperties);

		toggleMap();
	}

	function addMarkersFromJSON(jsonResponse) {
		if (!jsonResponse) {
			console.error("No JSON response");
			return;
		}
		if (google.maps.InfoWindow === undefined) {
			//console.error('InfoWindow is undefined');
			return;
		}

		// Create an InfoWindow instance
		const infoWindow = new google.maps.InfoWindow({
			content: "",
			disableAutoPan: true,
		});

		if (jsonResponse.properties && jsonResponse.properties.length > 0) {
			jsonResponse = jsonResponse.properties;
		}

		jsonResponse.forEach((property, i) => {
			// Create a label for the marker
			const label = i;
			//Convert label to stirng
			const labelString = label.toString();

			const parser = new DOMParser();
			// A marker with a custom inline SVG.
			const pinSvgString =
				'<svg class="fill-primary-200" xmlns="http://www.w3.org/2000/svg" width="30" viewBox="0 0 200.16 302.34"><defs/><path  d="M73.2 134.86c-6.73-7.91-12.38-16.93-16.41-27.07-10.7-26.91-6.52-42.48-1.13-50.8 5.54-8.56 14.73-13.55 25.95-14.02 12.47-.53 20.45 6.53 25.06 14.24 9.05-6.99 21.41-12.31 33.21-6.63 10.47 5.06 16.65 14.86 16.95 26.9.52 20.69-15.97 43.25-42.02 57.47-3.72 2.04-7.57 3.94-11.48 5.71 14.73 10.4 31.76 16.69 47.06 18.79 14.6 2.01 28.08.29 38.59-2.24 16.05-40.07 17.95-94.59-15.22-126.9C132.06-10.32 69.28-9.87 27.5 30.2c-31.25 29.98-33 78.53-19.48 117.93 3.22-.35 7.28-.79 12.01-1.34 11-1.56 31.71-5.1 53.17-11.93Z" class="cls-2"/><path d="M140.69 77.89c-.15-6.03-2.79-10.33-7.83-12.76-8.12-3.93-20.26 7.94-23.06 11.33-2 2.43-5.24 3.48-8.27 2.67a8.09 8.09 0 0 1-5.9-6.38c-.27-1.4-3.01-14.08-13.33-13.64-.29.01-.59.03-.9.06-4 .33-9.07 1.79-12.19 6.61-4.7 7.26-3.78 20.07 2.59 36.06 4.15 10.44 10.35 19.49 17.8 27.16 6.01-2.43 11.91-5.16 17.47-8.19 23.65-12.92 33.92-30.85 33.62-42.9ZM148.18 175.45c-20.39-2.8-43.48-12.13-62.14-27.85-32.84 11.66-65.47 15.53-71.63 16.18a155.4 155.4 0 0 0 1.56 3.17c22.03 43.07 35.74 68.02 84.42 135.39 41.58-59.14 57.59-82.14 80.13-127.08-2.39.34-4.86.62-7.4.83-7.75.63-16.16.57-24.95-.64Z" class="cls-2"/><path fill="#fff" stroke-width="0" d="M188.96 157.21c-10.5 2.54-23.98 4.25-38.59 2.24-15.3-2.1-32.33-8.39-47.06-18.79 3.91-1.77 7.76-3.67 11.48-5.71 26.05-14.22 42.54-36.78 42.02-57.47-.3-12.04-6.48-21.84-16.95-26.9-11.79-5.68-24.15-.37-33.21 6.63-4.61-7.71-12.59-14.77-25.06-14.24-11.22.47-20.41 5.46-25.95 14.02-5.39 8.33-9.57 23.9 1.13 50.8 4.04 10.14 9.68 19.16 16.41 27.07-21.47 6.84-42.18 10.37-53.17 11.93-4.73.55-8.79.99-12.01 1.34 1.86 5.41 4 10.65 6.4 15.65 6.16-.65 38.79-4.52 71.63-16.18 18.66 15.72 41.75 25.04 62.14 27.85 8.79 1.21 17.2 1.27 24.95.64 2.54-.21 5.01-.49 7.4-.83 1.32-2.63 2.66-5.33 4.03-8.12 1.56-3.19 3.04-6.51 4.41-9.93ZM71.79 101.83c-6.37-16-7.28-28.81-2.59-36.06 3.12-4.82 8.19-6.28 12.19-6.61.31-.03.61-.04.9-.06 10.32-.44 13.06 12.24 13.33 13.64a8.09 8.09 0 0 0 5.9 6.38c3.03.81 6.27-.24 8.27-2.67 2.8-3.39 14.94-15.26 23.06-11.33 5.05 2.43 7.68 6.73 7.83 12.76.3 12.05-9.97 29.99-33.62 42.9-5.57 3.04-11.46 5.76-17.47 8.19-7.45-7.66-13.65-16.72-17.8-27.16Z"/></svg>';
			const pinSvg = parser.parseFromString(pinSvgString, "image/svg+xml").documentElement;

			const marker = new window.AdvancedMarkerElement({
				position: { lat: parseFloat(property.latitude), lng: parseFloat(property.longitude) },
				content: pinSvg,
				map: map, // Directly assign the map here
			});

			// Add click listener for each marker to display an InfoWindow
			marker.addListener("click", () => {
				const contentString = `
                <div id="content" class="bg-white">
					<a href="${property.link}" target="_blank"><img src="${property.photos[0].large}" alt="${property.title}" class="w-full h-24 object-cover"></a>
					<div class="p-4">
						<h4 class="text-md font-bold mb-4">${property.title}</h4>
						<div class="flex p-4 border-t border-gray-300 text-gray-700 mt-auto">
							<div class="flex-1 inline-flex items-center">
								<svg class="h-6 w-6 text-gray-600 fill-current mr-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
									<path d="M0 16L3 5V1a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v4l3 11v5a1 1 0 0 1-1 1v2h-1v-2H2v2H1v-2a1 1 0 0 1-1-1v-5zM19 5h1V1H4v4h1V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h2V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1zm0 1v2a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V6h-2v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6H3.76L1.04 16h21.92L20.24 6H19zM1 17v4h22v-4H1zM6 4v4h4V4H6zm8 0v4h4V4h-4z"></path>
								</svg>
								<div><span class="text-gray-900 font-bold">${property.bedrooms}</span></div>
							</div>
							<div class="flex-1 inline-flex items-center">
								<svg class="h-6 w-6 text-gray-600 fill-current mr-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
									<path fill-rule="evenodd" d="M17.03 21H7.97a4 4 0 0 1-1.3-.22l-1.22 2.44-.9-.44 1.22-2.44a4 4 0 0 1-1.38-1.55L.5 11h7.56a4 4 0 0 1 1.78.42l2.32 1.16a4 4 0 0 0 1.78.42h9.56l-2.9 5.79a4 4 0 0 1-1.37 1.55l1.22 2.44-.9.44-1.22-2.44a4 4 0 0 1-1.3.22zM21 11h2.5a.5.5 0 1 1 0 1h-9.06a4.5 4.5 0 0 1-2-.48l-2.32-1.15A3.5 3.5 0 0 0 8.56 10H.5a.5.5 0 0 1 0-1h8.06c.7 0 1.38.16 2 .48l2.32 1.15a3.5 3.5 0 0 0 1.56.37H20V2a1 1 0 0 0-1.74-.67c.64.97.53 2.29-.32 3.14l-.35.36-3.54-3.54.35-.35a2.5 2.5 0 0 1 3.15-.32A2 2 0 0 1 21 2v9zm-5.48-9.65l2 2a1.5 1.5 0 0 0-2-2zm-10.23 17A3 3 0 0 0 7.97 20h9.06a3 3 0 0 0 2.68-1.66L21.88 14h-7.94a5 5 0 0 1-2.23-.53L9.4 12.32A3 3 0 0 0 8.06 12H2.12l3.17 6.34z"></path>
								</svg>
								<div><span class="text-gray-900 font-bold">${property.bathrooms}</span></div>
							</div>
							<div class="flex-1 inline-flex items-center">
								<svg class="h-6 w-6 text-gray-600 fill-current mr-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><<path d="M176 64A48 48 0 1 0 80 64a48 48 0 1 0 96 0zM64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM41.8 234.7L37.7 284c-2.3 28 19.8 52 47.8 52H112h32 16v16h-8V480c0 8.8 7.2 16 16 16c2.9 0 5.6-.8 8-2.1V511c-2.6 .7-5.2 1-8 1c-17.7 0-32-14.3-32-32V352H120V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V344.8c-22.1-11.5-36.4-35.4-34.2-62.1l4.1-49.3C29.3 191.9 64 160 105.6 160h44.8c7 0 13.8 .9 20.2 2.6c-1.3 5.1-2.1 10.5-2.5 15.9c-5.7-1.6-11.6-2.5-17.8-2.5H105.6c-33.3 0-61 25.5-63.8 58.7zM344 512c-2.8 0-5.4-.3-8-1V493.9c2.4 1.4 5.1 2.1 8 2.1c8.8 0 16-7.2 16-16V384h-8V368h16 32 48 21.6c10.6 0 18.3-10.2 15.4-20.4L445.9 210.8C440 190.2 421.2 176 399.7 176H368.3c-8.8 0-17.1 2.4-24.3 6.6c-.1-5.8-.7-11.5-1.9-17c8.1-3.6 17-5.6 26.2-5.6h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H456v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H376v96c0 17.7-14.3 32-32 32zM85.6 352c-4.7 0-9.2-.5-13.6-1.4V480c0 8.8 7.2 16 16 16s16-7.2 16-16V352H85.6zM432 64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM320 64a64 64 0 1 1 128 0A64 64 0 1 1 320 64zM440 384H408v96c0 8.8 7.2 16 16 16s16-7.2 16-16V384zM296 184a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-96 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm56 88c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V336c0-35.3-28.7-64-64-64zm-80 64c0-44.2 35.8-80 80-80s80 35.8 80 80v32c0 20.9-13.4 38.7-32 45.3V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V416H224v88c0 4.4-3.6 8-8 8s-8-3.6-8-8V413.3c-18.6-6.6-32-24.4-32-45.3V336z"/></svg>
								<div><span class="text-gray-900 font-bold">${property.sleeps}</span></div>
							</div>
						</div>
						<a class="w-full block text-center py-2 pl-3 pr-8 rounded-md bg-primary-200 text-white shadow-sm" href="${property.link}" target="_blank">View property</a>
					</div>
                </div>
            `;
				infoWindow.setContent(contentString);
				infoWindow.open(map, marker);
			});

			//Create LatLng object
			const latLng = new google.maps.LatLng(property.latitude, property.longitude);

			markers.push(marker); // Store the marker
			latLngs.push(latLng);
		});

		const svg = window.btoa(`
				<svg fill="#2e4876" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
				<circle cx="120" cy="120" opacity="1" r="70" />
				<circle cx="120" cy="120" opacity=".7" r="90" />
				<circle cx="120" cy="120" opacity=".3" r="110" />
				<circle cx="120" cy="120" opacity=".2" r="130" />
				</svg>`);

		const renderer = {
			render: ({ count, position }) =>
				new google.maps.Marker({
					label: {
						text: String(count),
						color: "white",
						fontFamily: '"neulis-sans", sans-serif',
						fontSize: "13px",
						fontWeight: "700",
					},
					icon: {
						url: `data:image/svg+xml;base64,${svg}`,
						scaledSize: new google.maps.Size(45, 45),
					},
					position,
					// adjust zIndex to be above other markers
					zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
				}),
		};

		// Initialize the marker clusterer
		markerCluster = new MarkerClusterer({
			markers,
			map,
			renderer,
		});

		//Loop through LatLngs to create bounds
		var bounds = new google.maps.LatLngBounds();
		latLngs.forEach(function (latLng) {
			bounds.extend(latLng);
		});
		//Fit map to bounds
		map.fitBounds(bounds);
	}

	function updateMarkers(jsonResponse) {
		if (markerCluster) {
			markerCluster.clearMarkers();
		}

		clearMarkers();

		addMarkersFromJSON(jsonResponse); // Add new markers based on the updated JSON data
	}

	// Assuming latestResponse is defined and has the structure as in your JSON response
	// Call initMap when needed, for example, upon a button click
	$("#view-map").on("click", function () {
		initMap().catch((e) => console.error(e));
	});

	$("#view-grid").on("click", function () {
		toggleMap();
	});

	function toggleMap() {
		$("#properties-map").toggleClass("hidden");
		$("#properties").toggleClass("hidden");

		$("#view-map").toggleClass("hidden");
		$("#view-grid").toggleClass("hidden");
		$(".order-by-container").toggleClass("hidden");
	}

	function clearMarkers() {
		markers.forEach((marker) => {
			marker.map = null;
			marker.setMap(null);
		});
		markers = []; // Reset the markers array
		latLngs = []; // Reset the latLngs array
	}

	if (document.querySelector(".search-availability")) {
		// Attach event listeners to form inputs
		$("form.search-sidebar, form.search-sidebar-mob").on("change", "input[type=checkbox], input[type=radio], input[type=range]", function () {
			showSearchLoader();
			var formData = collectFormValues();
			makeAjaxCall(formData);
		});

		$("form#search-properties").on("change", "select, input[type=hidden]", function () {
			showSearchLoader();
			var formData = collectFormValues();
			makeAjaxCall(formData);
		});

		//When orderBY select is changed
		$("select[name=orderBy]").on("change", function () {
			showSearchLoader();
			var formData = collectFormValues();
			makeAjaxCall(formData);
		});

		createSlider();
	}

	if (document.querySelector(".property-card")) {
		initPropertyCardSwiper();
	}

	function getOrdinalSuffix(day) {
		if (day > 3 && day < 21) return "th";
		switch (day % 10) {
			case 1:
				return "st";
			case 2:
				return "nd";
			case 3:
				return "rd";
			default:
				return "th";
		}
	}

	function formatDayWithSuffix(date) {
		const day = date.getDate();
		return day + getOrdinalSuffix(day);
	}

	// Function to initialize Lottie animations on elements with a specific class name
	function initLoadingAnimation() {
		// Check if 'lottie' is defined
		if (typeof lottie === "undefined") {
			//console.log('Lottie is not loaded');
			displayLoadingFallback();
			return;
		}

		// Find all elements with the class 'loading-animation-container'
		const animationContainers = document.querySelectorAll(".loading-animation-container");

		animationContainers.forEach((container) => {
			try {
				// Specify the path to your Lottie animation .lottie file
				const animationPath = "/app/themes/coastalholidays/assets/img/icon-white.json"; // Replace with the actual path

				// Initialize the Lottie animation for each container
				const animation = lottie.loadAnimation({
					container: container, // the DOM element that will contain the animation
					renderer: "svg", // Rendering mode: 'svg', 'canvas', or 'html'
					loop: true, // Loop the animation
					autoplay: true, // Play the animation immediately
					path: animationPath, // The path to the animation .lottie file
				});

				const speedMultiplier = 1.5; // Adjust this value to set the desired speed
				animation.setSpeed(speedMultiplier);

				// Store the animation instance for potential future use (like stopping/removing)
				container.animationInstance = animation;
			} catch (error) {
				console.error("Error loading loading animation:", error);
				displayLoadingFallback();
			}
		});
	}

	// Function to stop and remove Lottie animations from elements with a specific class name
	function removeLoadingAnimation() {
		const animationContainers = document.querySelectorAll(".loading-animation-container");

		animationContainers.forEach((container) => {
			if (container.animationInstance) {
				container.animationInstance.destroy(); // Stop and remove the animation
				delete container.animationInstance; // Clean up the reference
			}
		});
	}

	function displayLoadingFallback() {
		// Find all animation container elements
		const animationContainers = document.querySelectorAll(".loading-animation-container");

		// For each container, insert the custom div as fallback content
		animationContainers.forEach((container) => {
			// Remove any existing content
			container.innerHTML = "";

			// Create the custom div for fallback
			const fallbackDiv = document.createElement("div");
			fallbackDiv.className = "loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 mb-4";
			fallbackDiv.style.borderTopColor = "var(--color-primary-200)"; // Adjust this to match your project's way of defining primary color

			container.appendChild(fallbackDiv);
		});
	}

	//Mobile
	$(document).on("click", "#search-sidebar-mob", function () {
		const menus = document.querySelectorAll(".navbar-menu-info, .navbar-menu-products");
		menus.forEach(function (menu) {
			const backdropElement = menu.querySelector(".navbar-backdrop");
			backdropElement.classList.toggle("hidden");
			requestAnimationFrame(() => {
				// Toggle opacity classes after ensuring the element is not hidden.
				backdropElement.classList.toggle("opacity-0");
				backdropElement.classList.toggle("opacity-50");
			});
		});

		const filterElements = document.querySelectorAll(".filter-mobile");
		filterElements.forEach(function (filterElement) {
			filterElement.classList.toggle("hidden");
			requestAnimationFrame(() => {
				// Toggle opacity classes after ensuring the element is not hidden.
				filterElement.classList.toggle("opacity-0");
				filterElement.classList.toggle("opacity-100");
				filterElement.classList.toggle("-translate-x-12");
				filterElement.classList.toggle("translate-x-0");
			});
		});

		//$('.filter-mobile').toggleClass('hidden');
		if (!$(".filter-mobile").hasClass("hidden")) {
			collapseAllSections();
		}
	});

	$(document).on("click", "#search-mob", function () {
		const menus = document.querySelectorAll(".navbar-menu-info, .navbar-menu-products");
		menus.forEach(function (menu) {
			const backdropElement = menu.querySelector(".navbar-backdrop");
			if (!backdropElement.classList.contains("hidden")) {
				backdropElement.classList.toggle("opacity-0");
				backdropElement.classList.toggle("opacity-50");
				setTimeout(() => {
					// Now toggle 'hidden' after animations are completed.
					backdropElement.classList.toggle("hidden");
				}, 200);
			}
		});

		//Find search-backdrop and unhide
		const searchBackdrop = document.querySelector(".search-backdrop");
		searchBackdrop.classList.toggle("hidden");
		requestAnimationFrame(() => {
			// Toggle opacity classes after ensuring the element is not hidden.
			searchBackdrop.classList.toggle("opacity-0");
			searchBackdrop.classList.toggle("opacity-50");
		});

		const searchElements = document.querySelectorAll(".search-mobile");
		searchElements.forEach(function (searchElement) {
			searchElement.classList.toggle("hidden");
			requestAnimationFrame(() => {
				// Toggle opacity classes after ensuring the element is not hidden.
				searchElement.classList.toggle("opacity-0");
				searchElement.classList.toggle("opacity-100");
				searchElement.classList.toggle("-translate-x-12");
				searchElement.classList.toggle("translate-x-0");
			});
		});

		//Add pointer-events-none to #header using vanilla JS
		const header = document.querySelector("#header");
		header.classList.add("pointer-events-none");
	});

	function closeSearchSidebars(target) {
		const backdropElement = document.querySelector(".search-backdrop");
		if (!backdropElement.classList.contains("hidden")) {
			backdropElement.classList.toggle("opacity-0");
			backdropElement.classList.toggle("opacity-50");
			setTimeout(() => {
				// Now toggle 'hidden' after animations are completed.
				backdropElement.classList.toggle("hidden");
			}, 200);
		}

		const header = document.querySelector("#header");
		header.classList.remove("pointer-events-none");

		var filterElements;

		if (!target) {
			// Find all elements with the class 'filter-mobile' or 'search-mobile' that are not hidden
			filterElements = document.querySelectorAll(".filter-mobile:not(.hidden), .search-mobile:not(.hidden)");
		} else {
			filterElements = document.querySelectorAll("." + target);
		}

		filterElements.forEach(function (filterElement) {
			filterElement.classList.toggle("opacity-0");
			filterElement.classList.toggle("opacity-100");
			filterElement.classList.toggle("-translate-x-12");
			filterElement.classList.toggle("translate-x-0");
			setTimeout(() => {
				// Now toggle 'hidden' after animations are completed.
				filterElement.classList.toggle("hidden");
			}, 200);
		});
	}

	$(document).on("click", ".search-sidebar-close", function () {
		const target = $(this).data("target");
		closeSearchSidebars(target);
	});

	const backdropElements = document.querySelectorAll(".search-backdrop");
	if (backdropElements.length) {
		backdropElements.forEach(function (backdropElement) {
			backdropElement.addEventListener("click", function () {
				closeSearchSidebars(); // Close all menus when a close button is clicked
			});
		});
	}

	// Example usage:
	// Call `initLoadingAnimation()` when you want to start the animations,
	// for example, after dynamically inserting the HTML or when showing the animation containers.
	//initLoadingAnimation();

	// Call `removeLoadingAnimation()` when you want to stop and remove the animations from the page.
	// removeLoadingAnimation();
}
